var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cowinfo"},[_c('h1',[_vm._v(_vm._s(_vm.cowname))]),_c('br'),_vm._v(" Katalognr.: "+_vm._s(_vm.katnr)),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }